import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './App.vue';
import router from './router';
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import VeeValidate, { Validator } from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN';

Vue.config.productionTip = false;

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)

import Storage from 'vue-ls';

Vue.use(VeeValidate, {
    // This is the default
    inject: true,
    // Important to name this something other than 'fields'
    fieldsBagName: 'veeFields',
    // This is not required but avoids possible naming conflicts
    errorBagName: 'veeErrors',
    locale: 'zh_CN',
})
Validator.localize('zh_CN', zh_CN);

const options = {
    namespace: 'vuejs__', // key键前缀
    name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
    storage: 'local' // 存储名称: session, local, memory
};

Vue.use(Storage, options);

new Vue({
    router,
    data: {
        eventHub: new Vue()
    },
    render: h => h(App)
}).$mount('#app');